<template>
    <MainLayout>
		<div class="container">
            <div class="box">
                <b-row>
					<b-col>
						<h2 class="inline-heading">Importar reservas</h2>
					</b-col>
                    <b-overlay :show="loading" no-wrap rounded></b-overlay>
                    <b-col class="col-md-6">
                        <b-form-group class="d-flex justify-content-end">
                            <b-button class="mr-2 btn-success" :href="downloadFormatURL" target="_blank"><md-icon icon="download"/> Descargar formato</b-button>
                        </b-form-group>
					</b-col>
				</b-row>

                <hr/>

                <b-row>
                    <b-form-group label="Archivo .xlsx" class="col-md-4">
                        <input type="file" id="file" ref="file" @change="handleFileUpload()"/>
                    </b-form-group>
                    <b-form-group class="pt-2">
                        <b-button variant="dark" class="mt-3" @click="submitFile()"><md-icon icon="library_add"/> Validar datos</b-button>
                    </b-form-group>
                </b-row>

                <!-- Show error list -->
                <label class="text-danger" v-if="corrections">Errores encontrados</label>
                <ul v-if="message != ''">
                    <li>{{ message }}</li>
                </ul>

                <!-- Table view -->
                 <b-table v-if="errors.length" striped hover small bordered responsive :items="errors" ref="table"
                    show-empty empty-text="No se encontraron datos">
                    <!-- A custom formatted column -->
                    <template #cell(errores)="data">
                         <ul>
                            <li v-for="(error, index) in data.value" :key="index">
                                <small>{{ error }}</small>
                            </li>
                        </ul>
                    </template>
                </b-table>

                <!-- End error list -->
			</div>

            <br>

            <div class="box">
				<section id="success" v-if="bookingsCreated.length>0">
					<b-button variant="outline-primary" size="lg" @click="bookingsCreated=[]">
						<md-icon icon="arrow_back"></md-icon> Continuar Importando Reservas
					</b-button>
					<b-alert show variant="success" dismissible class="text-center mt-2">
						<b>Se crearón correctamente las reservas</b>
					</b-alert>

					<b-table striped hover small bordered responsive :items="bookingsCreated" class="text-nowrap borderless mt-3" ref="table-reservations-created"
						show-empty empty-text="No se encontraron datos" :tbody-tr-class="rowClass">
						<template #cell(scReservationId)="data">
							<b-button @click="resView({id:null,reservationId:data.item.scReservationId})" variant="outline-success">
								<span>Ver reservación</span>
							</b-button>
						</template>
					</b-table>
				</section>
				<section v-else>
					<div v-if="mapping" class="mb-5">
						<label class="text-muted">Seleccione una opción para las reservas</label>

						<b-form-group
							class="col-lg-4"
							label="Canal de venta"
						>
							<multiselect
								@select="selectSaleChannel"
								:options="salesChannelsOpts"
								v-model="saleChannel"
								:multiple="false"
								:show-labels="false"
								label="text"
								track-by="value"
							/>
						</b-form-group>

						<div class="row p-2">
							<h5 class="col-md-12">Tipos de servicio</h5>
							<div class="d-flex col-md-4 justify-content-between" v-for="(serviceType, index) in serviceTypes" :key="serviceType">
								<div class="w-100">
									<label>{{ serviceType }} : </label>
									<multiselect
										@select="onSelectMatchType($event, serviceType)"
										:options="serviceTypesMap"
										v-model="typeSelects[index].model"
										:id="'service-type-' + index"
										:multiple="false"
										:show-labels="false"
										label="text"
										track-by="value"
									/>
								</div>
							</div>
						</div>
					</div>

					<b-row>
						<b-col md class="mb-2">
							<div class="mr-4">
								<span>{{rowsMessage}}</span>
								<b-form-select size="sm" class="ml-2" id="perPageSelector" v-model="perPage" :options="perPageOptions" @change="submitFile(false)"></b-form-select>
							</div>
						</b-col>
						<b-col md class="text-right">
							<b-row no-gutters>
								<b-col >
									<b-pagination v-model="currentPage" align="right" :total-rows="totalRows" :per-page="perPage" @input="submitFile(false)"/>
								</b-col>
							</b-row>
						</b-col>
					</b-row>

					<b-table striped hover small bordered responsive :items="items" class="text-nowrap borderless" ref="table"
						show-empty empty-text="No se encontraron datos" :tbody-tr-class="rowClass">
					</b-table>



					<div class="d-flex justify-content-end">
						<b-button v-if="mapping" variant="dark" class="mr-2" @click="submitFileMap()"><md-icon icon="library_add"/>Generar reservas</b-button>
					</div>
				</section>
            </div>

        </div>
		<FormReservation
			:tsSelectedId="resSelected.tsSelectedId"
			:model-id="resSelected.modalModelId"
			:copy-from-id="resSelected.copyResId"
			:formTypeWork="resSelected.formTypeWork"
			@changeId="resSelected.modalModelId = $event"
			v-model="resSelected.show"
		/>
    </MainLayout>
</template>

<script>
    import MainLayout from '../layout/MainLayout.vue';
    import Multiselect from "vue-multiselect";
	import FormReservation from "@/components/sections/reservation/formReservation/index";

    export default {
        components: { Multiselect, MainLayout ,FormReservation},
        props: {
            showSelectAll: {
				type : Boolean,
				required: false,
				default : false
			},
            model: {
                type: Array,
                required: false,
            },
            valueType: [String, Object]
        },
        data() {
            return {
                file: '',
                importResult: '',
                loading:false,
                items:[],
                dateFormat: 'Y-m-d',
                perPage:10,
				currentPage:1,
				totalRows:0,
                perPageOptions:[
					{value:10,text:10},
					{value:50,text:50},
					{value:100,text:100},
					{value:200,text:200},
					{value:500,text:500},
				],
				selectAll: false,
                selected:null,
                responses: [],
                errors: [],
                corrections: false,
                message: '',
                mapping: false,
                salesChannels: [],
                saleChannel: null,
                serviceTypes: [],
                serviceTypesMap: [],
                typeSelects: [],
                mappedServices: [],
				resSelected: {
					modalModelId: -1,
					tsSelectedId: -1,
					copyResId: -1,
					formTypeWork:"",
					show:false
				},
				bookingsCreated:[]
            }
        },
        computed:{
			offset(){ return (this.currentPage-1)*this.perPage },
			rowsFrom(){ return this.offset+1},
			rowsTo(){ return Math.min(this.offset+this.perPage,this.totalRows) },
			rowsMessage() {
				if(this.totalRows){
					return "Mostrando : " + (((this.currentPage-1)*this.perPage)+1)  +" a "+Math.min((this.perPage*this.currentPage),this.totalRows) +" registros de "+this.totalRows;
				}else{
					return "Mostrando 0 de 0";
				}

			},
            downloadFormatURL() {
                return `${process.env.VUE_APP_API_URL}/imports/downloadFormat`
            },
            salesChannelsOpts() {
                return this.salesChannels.map(sc => ({value: sc.id, text: sc.code}))
            }
        },
        methods:{
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
            },
            submitFile(reloadMapping = true) {
                this.loading     = true
                this.corrections = false
                this.message     = false
                this.errors      = [];
				this.bookingsCreated=[];

                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('dateFormat', this.dateFormat)
                formData.append('limit', this.perPage)
                formData.append('offset', this.offset)
                this.$root.api.post(`/imports/importxls`,
                    formData, {
                        timeout: 1000 * 60 * 2, //2 minutes
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((res) => {

                    this.importResult = res.data;
                    this.loading      = false

                    //Error reading file
                    if (this.importResult.error) {

                        this.mapping     = false
                        this.corrections = true
                        this.message     = this.importResult.message
                        this.items       = []
                        this.totalRows   = 0
                        this.$root.showAlert('Error: ' + this.importResult.message, {variant:'danger'})
                        console.log('error: ' + this.importResult.message)
                        return false
                    }

                    this.errors    = this.importResult.data.errors
                    this.selected  = 1
                    this.items     = res.data.data.bookings
                    this.totalRows = res.data.data.totalBookings

                    //Not reload inputs
                    if (!reloadMapping) return false

                    if (Object.keys(this.importResult.data.errors).length > 0) {
                        this.mapping     = false
                        this.corrections = true
                        this.$root.showAlert("Se encontraron errores", {variant:'warning'})
                        return false
                    } else {
                        this.mapping = true
                    }

                    //Map data collected
                    this.serviceTypes    = res.data.data.service_types
                    this.serviceTypesMap = res.data.data.service_types_map

                    if (Object.keys(this.serviceTypes).length > 0) {
                        this.typeSelects = []
                        for(let type in this.serviceTypes) {
                            console.log(type)
                            this.typeSelects.push({model: null})
                        }

                        this.mapping = true
                    }

                }).catch(error => {
                    this.$root.handleRequestError(error)
                    this.loading = false
                });
            },
            submitFileMap() {

                if (this.saleChannel == null) {
                    this.$root.showAlert("Seleccione un canal de venta", {variant:'danger'})
                    return false
                }

                this.loading = true

                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('confirmation', true)
                formData.append('salesChannelId', this.saleChannel.value)
                formData.append('mappedServices', JSON.stringify(this.mappedServices))

                this.$root.api.post(`/imports/importxls`, formData).then((res) => {

                    this.corrections = false
                    this.message     = false
                    this.loading     = false

                    if (res.data.error) {

                        this.corrections = true
                        this.message     = res.data.message
                        this.$root.showAlert(res.data.message, {variant:'danger'})
						window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                        return false
                    }

                    this.mappedServices = []
                    this.saleChannel    = []

                    //Reload page
                    this.$root.showAlert("Se registraron las reservas correctamente")
                    this.reload()
					this.bookingsCreated     = res.data.data.bookings

                }).catch(error => {
                    this.$root.handleRequestError(error)
                    this.loading = false;
                })
            },
            updateTable(){
				this.$refs.table.refresh()
			},
            rowClass(item) {
                //Indicamos donde se encuentra el error dentro de los datos
                for(let error of this.errors) {
                    if (item.indice === error.indice) return 'table-danger'
                }
            },
            reload() {
                this.mapping   = false
                this.items     = []
                this.totalRows = 0
                this.$refs.file.value = null
                this.responses = []
				this.file='';
            },
            selectSaleChannel(selected) {
                this.saleChannel = selected
            },
            loadSalesChannelsOpts() {
                this.$root.api.get(`/sales-channels?limit=2000`).then(res => {
                    this.salesChannels = res.data.rows;
                });
            },
            onSelectMatchType(event, type) {
                //Quitamos si existe ya uno previamente y fue actualizado
                this.mappedServices.map((match, index) => {
                    if (match.index == type) {
                        this.mappedServices.splice(index, 1)
                    }
                })

                this.mappedServices.push({index: type, match: event})
            },
			resView(item) {
			this.resSelected.tsSelectedId = item.id;
			this.resSelected.copyResId = -1;
			this.resSelected.modalModelId = item.reservationId;
			this.resSelected.show = true;
			//configuramos el estado de formulario formService
			this.resSelected.formTypeWork = "viewForm";
		},
        },
        mounted(){
            this.loadSalesChannelsOpts()
        }
    }
</script>

<style scoped>
	.active {
		color: cornflowerblue;
	}
	#perPageSelector{
		width: 80px
	}
</style>
